// extracted by mini-css-extract-plugin
module.exports = {"MarketplaceContainer":"marketplace-container_MarketplaceContainer__D0sEt typography_bodyFont__ybYPk"};